import h from 'hyperscript';
import './palette-item.css';

const NAME = 'd-palette-item';
const SELECTED_CLASS = 'is-selected';
export const SELECT_EVENT = 'palette-item-selected';
export const DESELECT_EVENT = 'palette-item-deselected';

export class PaletteItem extends HTMLElement {

  #idx;
  #paletteId;
  #icon;
  #label;
  #isSelected;
  #withLabel;
  #className;

  constructor (item, { isSelected = false, withLabel = true, className } = {}) {
    super();
    this.#idx = item.idx;
    this.#paletteId = item.paletteId;
    this.#icon = item.imageSrc;
    this.#label = item.printName;
    this.#withLabel = withLabel;
    this.#className = className;
    this.isSelected = isSelected;
  }

  connectedCallback () {
    this.classList.add(NAME);
    if (this.#className) {
      this.classList.add(this.#className);
    }
    this.appendChild(this._createIcon());
    if (this.#withLabel) {
      this.appendChild(this._createLabel());
    }

    this.addEventListener('click', (event) => {
      if (!this.#isSelected) {
        this.isSelected = true;
        this._fireEvent(SELECT_EVENT);
      }
    });
  }

  _createIcon () {
    const img = h('img');
    img.src = this.#icon;
    return h('.palette-item-icon', img);
  }

  _createLabel () {
    return h('.palette-item-label', this.#label);
  }

  set isSelected (value) {
    if (this.#isSelected && !value) {
      this._fireEvent(DESELECT_EVENT);
    }
    this.#isSelected = value;
    this.classList.toggle(SELECTED_CLASS, value);
  }

  get isSelected () {
    return this.#isSelected;
  }

  _fireEvent (eventName) {
    const selectEvent = new CustomEvent(eventName, { detail: this, bubbles: true });
    this.dispatchEvent(selectEvent);
  }

  get paletteId () {
    return this.#paletteId;
  }

  get idx () {
    return this.#idx;
  }

}

customElements.define(NAME, PaletteItem);
